import React from "react";

const SpinAlert = ({ modalTitle, modalMessage, winnerList, closeModal }) => {
  return (
    <div
      _ngcontent-serverapp-c93
      id="spinAlert"
      className="overlay"
      style={{ display: "flex" }}
    >
      <div
        style={{ top: "30%" }}
        _ngcontent-serverapp-c93
        className="frame-wrap"
      >
        <div _ngcontent-serverapp-c93 className="news-wrap news-wrap-frame">
          <div _ngcontent-serverapp-c93 className="side-head">
            <h3 _ngcontent-serverapp-c93>{modalTitle}</h3>
          </div>
          <div _ngcontent-serverapp-c93 className="side-content">
            <p _ngcontent-serverapp-c93>{modalMessage}</p>
          </div>
          <footer onClick={closeModal} _ngcontent-serverapp-c93>
            <a _ngcontent-serverapp-c93 className="btn-send">
              OK
            </a>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default SpinAlert;
